import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { CommonModule, DecimalPipe } from '@angular/common';
import { RouteGuardHelper } from '@helpers/route.guard.helper';
import { SharedModule } from '@app/modules/shared.module';
import { UtilsModule } from '@app/modules/utils.module';
import { TranslateModule } from '@ngx-translate/core';
import { VerificationDialog } from '@components/verification-dialog';
import { LeftSportsMenuDialog } from '@app/dialogs/left-sport-menu.dialog';
import { SignOutDialog } from '@app/dialogs/sign-out.dialog';
import { CasinoRoutingDialog } from '@components/casino-routing-dialog';
import { WithdrawAdditionalInfoDialog } from '@sharedTemplates/withdraw/withdrawAdditionalInfo.dialog';
import { SureRoutingDialog } from '@components/sure-routing-dialog.ts';
import { LoadingDialog } from '@app/dialogs/loading.dialog';
import { LoadingTicketDialog } from '@app/dialogs/loading-ticket.dialog';
import { DepositFrameDialog } from '@components/deposit-frame-dialog';
import { TransactionsDialog } from '@components/transactions.dialog';
import { StandingsDialogComponent } from '@components/standings.dialog.component';
import { PayoutDialog } from '@components/payout.dialog';
import { BottomDialog } from '@components/bottom-dialog';
import { MatchDetailDialog } from '@components/match-detail-dialog';
import { HeadToHeadDialog } from '@components/headtohead-dialog';
import { BarcodeDialog } from '@components/barcode.dialog.component';
import { BoostInfoModal } from '@components/boost-info-modal';
import { FreeBetInfoModal } from '@components/freebet-info-modal';
import { QRDialog } from '@components/qr.dialog.component';
import { ticketDetailModalComponent } from '@components/mostPlayedTicket/ticketDetailModal/ticket-detail-modal.component';
import { ConsentScreenDialog } from '@components/consent-screen-dialog.component';
import { CasinoRegisterModal } from '@components/casino-register-modal';
import { BonusSummaryModal } from '@components/bonus-summary-modal';
import { CustomFormsModule } from '@app/modules/forms.module';
import { RouterModule } from '@angular/router';
import { QRCodeModule } from 'angularx-qrcode';
import { MaterialImports } from '@environments/environment';
import { NgxBarcodeModule } from 'ngx-barcode';
import { EventDetailsModule } from '@components/eventDetails/eventDetails.module';
import { LiveEventDetailsModule } from '@components/eventDetails/LiveEventDetails.module';
import { CurrentSlipModule } from '@components/currentSlip/CurrentSlip.module';
import { LiveModule } from '@app/components/sports/live.module';
import { BetsAcceptedModal } from '@app/components/bets-accepted-modal';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    UtilsModule,
    TranslateModule,
    CustomFormsModule,
    RouterModule,
    QRCodeModule,
    MaterialImports,
    NgxBarcodeModule,
    EventDetailsModule,
    LiveEventDetailsModule,
    CurrentSlipModule,
    LiveModule,
  ],
  declarations: [
    VerificationDialog,
    LeftSportsMenuDialog,
    SignOutDialog,
    CasinoRoutingDialog,
    WithdrawAdditionalInfoDialog,
    SureRoutingDialog,
    LoadingDialog,
    LoadingTicketDialog,
    DepositFrameDialog,
    TransactionsDialog,
    StandingsDialogComponent,
    PayoutDialog,
    BottomDialog,
    MatchDetailDialog,
    HeadToHeadDialog,
    BarcodeDialog,
    BoostInfoModal,
    FreeBetInfoModal,
    QRDialog,
    ticketDetailModalComponent,
    ConsentScreenDialog,
    CasinoRegisterModal,
    BonusSummaryModal,
    BetsAcceptedModal,
  ],
  exports: [
    VerificationDialog,
    LeftSportsMenuDialog,
    SignOutDialog,
    CasinoRoutingDialog,
    WithdrawAdditionalInfoDialog,
    SureRoutingDialog,
    LoadingDialog,
    LoadingTicketDialog,
    DepositFrameDialog,
    TransactionsDialog,
    StandingsDialogComponent,
    PayoutDialog,
    BottomDialog,
    MatchDetailDialog,
    HeadToHeadDialog,
    BarcodeDialog,
    BoostInfoModal,
    FreeBetInfoModal,
    QRDialog,
    ticketDetailModalComponent,
    ConsentScreenDialog,
    CasinoRegisterModal,
    BonusSummaryModal,
    BetsAcceptedModal,
  ],
  providers: [ScrollDispatcher, RouteGuardHelper, DecimalPipe],
})
export class DialogSharedModule {}
